import { styled } from '@mui/material';

export const UploadedFileListWrap = styled('div')({});

export const UploadedFileListTitle = styled('h4')({
	margin: 0,
	fontWeight: 500,
});

export const UploadedFileList = styled('ul')({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	gap: '8px',
	listStyleType: 'none',
	paddingLeft: '4px',
	margin: 0,
});
